import styled from 'styled-components'

export const Wrapper = styled.div`
    ${(props) => props.theme.typo.bodyS}
    ${(props) => props.theme.boxShadow.level5};
    background: ${(props) => props.theme.color.c200};
    color: ${(props) => props.theme.color.black};
    border-radius: 6px;
    padding: 10px;
    margin: 20px auto;
    max-width: 1170px;

    ul,
    ol {
        list-style-position: inside;
    }
`
